import Vue from 'vue';
import {
  NavBar,
  Icon,
  Tab,
  Tabs,
  Field,
  Col,
  Row,
  DropdownMenu,
  DropdownItem,
  Cell,
  CellGroup,
  Sticky,
  Panel,
  Form,
  Picker,
  Popup,
  Area,
  Dialog,
  DatetimePicker,
  Grid,
  GridItem,
  Checkbox,
  CheckboxGroup,
  Lazyload,
  Image,
  Collapse,
  CollapseItem,
  RadioGroup,
  Radio,
  Rate,
  Uploader,
  Button,
  Toast,
  Loading,
  List,
  ActionSheet,
  ImagePreview,
  Overlay,
} from 'vant';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import './common/css/reseat.styl';
import '../reastVant.styl';
import axios from 'axios';

// if (process.env.NODE_ENV === 'development') {
//   new VConsole();
// }

Vue.prototype.$axios = axios;
import QS from 'qs';
Vue.prototype.qs = QS;

// import Vant from "vant";
// import "vant/lib/index.css";
import 'vant/lib/nav-bar/style/less';
import 'vant/lib/icon/style/less';

import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard;

Vue.config.productionTip = false;

Vue.use(NavBar)
  .use(Icon)
  .use(Tab)
  .use(Tabs)
  .use(Field)
  .use(Col)
  .use(Row)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Cell)
  .use(CellGroup)
  .use(Sticky)
  .use(Panel)
  .use(Form)
  .use(Picker)
  .use(Popup)
  .use(Area)
  .use(Dialog)
  .use(DatetimePicker)
  .use(Grid)
  .use(GridItem)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Lazyload)
  .use(Image)
  .use(Collapse)
  .use(CollapseItem)
  .use(RadioGroup)
  .use(Radio)
  .use(Rate)
  .use(Uploader)
  .use(Button)
  .use(Toast)
  .use(Loading)
  .use(List)
  .use(ActionSheet)
  .use(ImagePreview)
  .use(Overlay);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
